import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

export interface AdminSidebarItem {
  title: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-evo-admin-sidebar',
  templateUrl: './evo-admin-sidebar.component.html',
  styleUrls: ['./evo-admin-sidebar.component.css']
})
export class EvoAdminSidebarComponent implements OnInit {

  items: AdminSidebarItem[] = [
    { title: 'School Years', route: '/admin/schoolYears', icon: 'calendar' },
    { title: 'Organizations', route: '/admin/organizations', icon: 'organization' },
    { title: 'Pricing', route: '/admin/pricing', icon: 'tag' },
    { title: 'Books', route: '/admin/books', icon: 'book' },
    { title: 'Users', route: '/admin/users', icon: 'user' },
    { title: 'Students', route: '/admin/students', icon: 'graduation' },
    { title: 'Questions', route: '/admin/questions', icon: 'help' },
    { title: 'Skill Groups', route: '/admin/skillGroups', icon: 'layers' },
    { title: 'Schools', route: '/admin/schools', icon: 'home' },
    { title: 'Objectives', route: '/admin/objectives', icon: 'target' },
    { title: 'Placement Tests', route: '/admin/placementTests', icon: 'clipboard' },
    { title: 'Competitions', route: '/admin/competitions', icon: 'trophy' },
    { title: 'Integrations', route: '/admin/integrations', icon: 'integrations' }
  ];

  constructor(private router: Router) { }

  ngOnInit() {
  }

  onShowUserViewClicked() {

    this.router.navigate(['platform', 'dash']);

  }

}
